// robo-AMP35：页脚后 Tab — Firework(主内容末) → UC → Refer → Chat → Back to top
var ROBO_FIXED_WIDGET_IDS = {
  cmpLoader: "usercentrics-cmp",
  tabStart: "robo-fixed-widgets-tab-start",
  suspended: "suspendedNavigation",
};

function isUsercentricsUiNode(el) {
  if (!el || el.nodeType !== 1) return false;

  // SVG 元素的 el.id 是 SVGAnimatedString 对象，需用 getAttribute 取字符串
  var id = el.getAttribute("id") || "";
  if (id === ROBO_FIXED_WIDGET_IDS.cmpLoader) return false;
  if (id === ROBO_FIXED_WIDGET_IDS.tabStart) return false;
  if (id === ROBO_FIXED_WIDGET_IDS.suspended) return false;

  if (id.indexOf("usercentrics") === 0 || id.indexOf("uc-") === 0) return true;
  if (el.getAttribute("data-testid") === "uc-app-container") return true;
  if (el.querySelector("[id^='usercentrics-'], [id^='uc-']")) return true;
  return false;
}

function fixFireworkTabPosition() {
  var container = document.querySelector(".firework-container");
  var cmpLoader = document.getElementById(ROBO_FIXED_WIDGET_IDS.cmpLoader);
  if (!container || !cmpLoader || !cmpLoader.parentNode) return;

  var mainFooter = document.querySelector(".ro_bootsrap-footer");
  if (!mainFooter) return;

  var tabStart = document.getElementById(ROBO_FIXED_WIDGET_IDS.tabStart);
  var afterFooter =
    mainFooter.compareDocumentPosition(container) &
    Node.DOCUMENT_POSITION_FOLLOWING;
  var beforeFloats =
    !tabStart ||
    (container.compareDocumentPosition(tabStart) &
      Node.DOCUMENT_POSITION_FOLLOWING);

  if (afterFooter && beforeFloats) return;

  cmpLoader.parentNode.insertBefore(container, cmpLoader);
}

function fixUsercentricsTabPosition() {
  var cmpLoader = document.getElementById(ROBO_FIXED_WIDGET_IDS.cmpLoader);
  var tabStart = document.getElementById(ROBO_FIXED_WIDGET_IDS.tabStart);
  if (!cmpLoader || !tabStart || !tabStart.parentNode) return;

  var parent = tabStart.parentNode;
  var ucNodes = [];

  Array.prototype.slice.call(document.body.children).forEach(function (el) {
    if (el === tabStart || el === cmpLoader) return;
    if (!isUsercentricsUiNode(el)) return;
    if (
      tabStart.compareDocumentPosition(el) &
      Node.DOCUMENT_POSITION_FOLLOWING
    ) {
      ucNodes.push(el);
    }
  });

  ucNodes.forEach(function (ucEl) {
    parent.insertBefore(ucEl, tabStart);
  });
}

function fixFixedWidgetsFocusOrder() {
  fixFireworkTabPosition();
  fixUsercentricsTabPosition();

  var tabStart = document.getElementById(ROBO_FIXED_WIDGET_IDS.tabStart);
  var parent = document.body;
  var ordered = [
    document.getElementById(ROBO_FIXED_WIDGET_IDS.suspended),
    document.querySelector(".embeddedMessagingConversationButtonWrapper"),
    document.querySelector(".as-btt-btn"),
  ].filter(Boolean);

  if (ordered.length === 0) return;

  var anchor = tabStart;
  if (tabStart && tabStart.parentNode) {
    parent = tabStart.parentNode;
  }

  var alreadyOrdered =
    !anchor ||
    (anchor.nextElementSibling === ordered[0] &&
      ordered.every(function (el, i) {
        return (
          i === ordered.length - 1 ||
          el.nextElementSibling === ordered[i + 1]
        );
      }));

  if (alreadyOrdered) return;

  ordered.forEach(function (el) {
    if (!anchor) {
      parent.appendChild(el);
      anchor = el;
      return;
    }
    if (anchor.nextElementSibling !== el) {
      parent.insertBefore(el, anchor.nextElementSibling);
    }
    anchor = el;
  });
}

window.addEventListener("onEmbeddedMessagingReady", (event) => {
  console.log("Received the onEmbeddedMessagingConversationStarted event…");
  console.log("Event detail: ", event.detail);
  fixEmbeddedMessagingPosition();
  fixFixedWidgetsFocusOrder();
  /* 防止 Salesforce 后续重写 */
  const embeddedMsgObserver = new MutationObserver(function () {
    fixEmbeddedMessagingPosition();
    fixFixedWidgetsFocusOrder();
  });
  embeddedMsgObserver.observe(document.body, { childList: true, subtree: true });

  embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({
    Country: {
      value: "United States of America",
    },
    Language: {
      value: "English",
      isEditableByEndUser: true,
    },
  });
});
window.addEventListener("onEmbeddedMessagingWindowClosed", (event) => {
  sendMessage();
});
function sendMessage() {
  embeddedservice_bootstrap.utilAPI.sendTextMessage("Customer already left");
}
function initEmbeddedMessaging() {
  try {
    embeddedservice_bootstrap.settings.language = "en_US"; // For example, enter 'en' or 'en-US'

    embeddedservice_bootstrap.init(
      "00D2w000002loIc",
      "Messaging",
      "https://roborockasia.my.site.com/ESWMessaging1766467073151",
      {
        scrt2URL: "https://roborockasia.my.salesforce-scrt.com",
      }
    );
  } catch (err) {
    console.error("Error loading Embedded Messaging: ", err);
  }
}
function fixEmbeddedMessagingPosition() {
  const iframe = document.querySelector("iframe.embeddedMessagingFrame");

  if (iframe) {
    iframe.style.setProperty("z-index", "2147483647", "important");
  }
}

function addChatExpertMessage() {
  const embeddedMessagingIconChat = document.querySelector(
    ".embeddedMessagingIconChat"
  );

  if (
    embeddedMessagingIconChat &&
    !embeddedMessagingIconChat.nextElementSibling?.classList.contains("message")
  ) {
    const messageSpan = document.createElement("p");
    messageSpan.className = "message";
    messageSpan.textContent = "Chat with an expert";
    embeddedMessagingIconChat.insertAdjacentElement("afterend", messageSpan);
  }
}

window.addEventListener("UC_UI_INITIALIZED", fixFixedWidgetsFocusOrder);
window.addEventListener("UC_CONSENT", fixFixedWidgetsFocusOrder);

// 观察DOM变化，当聊天图标加载后添加文本
const embeddedMsgObserver = new MutationObserver((mutations) => {
  addChatExpertMessage();
  fixFixedWidgetsFocusOrder();
});

// 开始观察
if (document.body) {
  embeddedMsgObserver.observe(document.body, { childList: true, subtree: true });
}

// 也尝试在页面加载后延迟执行
setTimeout(addChatExpertMessage, 1000);
setTimeout(addChatExpertMessage, 2000);
setTimeout(fixFixedWidgetsFocusOrder, 0);
setTimeout(fixFixedWidgetsFocusOrder, 1000);
setTimeout(fixFixedWidgetsFocusOrder, 2000);
setTimeout(fixFixedWidgetsFocusOrder, 4000);
